import api from './api';

// Wiedervorlagen (backend/routes/wiedervorlagen_router.py) – inkl. Lead-Bearbeitung und KI-PostManager in der Liste
const wiedervorlagenService = {
  liste: async (params = {}) => (await api.get('/wiedervorlagen', { params })).data,
  laden: async (id) => (await api.get(`/wiedervorlagen/${id}`)).data,
  anlegen: async (daten) => (await api.post('/wiedervorlagen', daten)).data,
  aendern: async (id, daten) => (await api.put(`/wiedervorlagen/${id}`, daten)).data,
  erledigen: async (id, erledigt = true) => (await api.post(`/wiedervorlagen/${id}/erledigt`, { erledigt })).data,
  loeschen: async (id) => (await api.delete(`/wiedervorlagen/${id}`)).data,
  projekteSuchen: async (suche) => (await api.get('/wiedervorlagen/projekte', { params: { suche } })).data?.projekte || [],
};

// Nach dem Speichern/Erledigen: andere Listen (Kalender, Tabs) aktualisieren
export const WV_GEAENDERT = 'ew-wiedervorlagen-geaendert';
export const wvGeaendertMelden = () => window.dispatchEvent(new Event(WV_GEAENDERT));

export default wiedervorlagenService;
